import { useCallback, useEffect, useState } from "react";

export type ChatListItem = {
  chat_id: string;
  title: string;
  last_message_at?: string | null;
  message_count?: number;
};

export const useChatList = (projectId: number | null | undefined) => {
  const [items, setItems] = useState<ChatListItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchList = useCallback(async () => {
    if (!projectId) {
      setItems([]);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/list-chats?project_id=${projectId}`,
        { credentials: "include" }
      );
      if (!res.ok) {
        const body = await res.json().catch(() => null);
        throw new Error(body?.detail || body?.error || "履歴一覧の取得に失敗しました。");
      }
      const json = (await res.json()) as ChatListItem[];
      setItems(json ?? []);
    } catch (e: any) {
      setError(e.message ?? "履歴一覧の取得に失敗しました。");
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  return { items, loading, error, refetch: fetchList };
};
